/**
 * Check-in colours that sit outside the player's light/dark schemes (#2691).
 *
 * The entrance kiosk is a single-purpose device read from across the room;
 * the approved kiosk frames fix its palette (ready slate, emerald green, red)
 * regardless of the player app's scheme. The player's check-in code card keeps
 * the approved soft lift under the always-white QR.
 */
export const KIOSK_PALETTE = {
  ready: "#0B0F17",
  frameFrom: "#1E293B",
  frameTo: "#0F172A",
  frameIcon: "#334155",
  line: "#334155",
  accent: "#34D399",
  green: "#059669",
  greenDeep: "#047857",
  red: "#DC2626",
  white: "#FFFFFF",
  text2: "#94A3B8",
  text3: "#64748B",
  alert: "#FCA5A5",
  error: "#F87171",
  onColor: "rgba(255,255,255,.85)",
  ring: "rgba(255,255,255,.9)",
  track: "rgba(255,255,255,.25)",
  dotEmpty: "rgba(255,255,255,.45)",
  hover: "rgba(255,255,255,.1)",
  scrim: "rgba(11,15,23,.8)",
} as const;

export const CHECK_IN_CODE_SHADOW = "0 10px 30px rgba(15,23,42,.08)";
